import AdvancedSearch from './Search/AdvancedSearchPanel';

function NavigationSearch(props) {
   const { variant, className } = props;

   return <AdvancedSearch className={className} variant={variant} />;
}

export default NavigationSearch;
